'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Route error:', error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0F0E0C',
        color: '#F5F0EB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div style={{ maxWidth: '480px', width: '100%', textAlign: 'center' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: 'rgba(0, 120, 112, 0.15)',
            border: '1px solid rgba(0, 120, 112, 0.3)',
            marginBottom: '24px',
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#007870" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <h1
          style={{
            fontFamily: '"Barlow Condensed", sans-serif',
            fontSize: '32px',
            fontWeight: 700,
            letterSpacing: '-0.01em',
            margin: '0 0 12px 0',
            color: '#F5F0EB',
          }}
        >
          Something went wrong
        </h1>
        <p
          style={{
            fontSize: '15px',
            lineHeight: 1.6,
            color: '#928B83',
            margin: '0 0 32px 0',
          }}
        >
          An unexpected error occurred. Please try again, or head back to the homepage.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={reset}
            style={{
              background: '#007870',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              minHeight: '48px',
            }}
          >
            Try again
          </button>
          <a
            href="/"
            style={{
              background: 'transparent',
              color: '#F5F0EB',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: 600,
              textDecoration: 'none',
              minHeight: '48px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Go to homepage
          </a>
        </div>
        {error.digest && (
          <p style={{ fontSize: '11px', color: '#6B6661', marginTop: '32px', fontFamily: 'monospace' }}>
            Error ID: {error.digest}
          </p>
        )}
      </div>
    </div>
  );
}
